import { useState } from 'react';

const EXPAND_STORAGE_KEY = 'azma-navigation-expanded';

export function useNavigationPinState() {
    const [isExpanded, setIsExpanded] = useState(() => {
        let stored = null;
        try {
            stored = localStorage.getItem(EXPAND_STORAGE_KEY);
        } catch {
            return false;
        }

        if (stored === '1' || stored === '0') {
            return stored === '1';
        }

        return window.innerWidth > 1550;
    });

    return [isExpanded, setIsExpanded];
}